export default {
  data() {
    return {};
  },
  methods: {
    stopBtnSpin(u) {
      if (u === "msnew") {
        this.enableSpinnerAddBtn = false;
      }
    },
    stopBtnSpinAll() {
      this.btnSpin = false;
      this.btnSpinChangeDetail = false;
      this.btnSpinAccessRequest = false;
      this.btnSpinDocumentComms = false;
      this.btnSpinNewMaintStrategy = false;
      this.btnSpinUpdateMaintStrategy = false;
      this.btnSpinNewMaintPlan = false;
      this.btnSpinAdminReview = false;
      this.btnSpinGetRegisterList = false;
      this.btnSpinGetTree = false;
    }
  }
};
